var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z",
    fill: "#314155",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 68C50.2091 68 52 66.2091 52 64C52 61.7909 50.2091 60 48 60C45.7909 60 44 61.7909 44 64C44 66.2091 45.7909 68 48 68Z",
    fill: "#EE4352",
    fillOpacity: 0.969
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52C46.9391 52 45.9217 51.5786 45.1716 50.8284C44.4214 50.0783 44 49.0609 44 48V32C44 30.9391 44.4214 29.9217 45.1716 29.1716C45.9217 28.4214 46.9391 28 48 28C49.0609 28 50.0783 28.4214 50.8284 29.1716C51.5786 29.9217 52 30.9391 52 32V48C52 49.0609 51.5786 50.0783 50.8284 50.8284C50.0783 51.5786 49.0609 52 48 52Z",
    fill: "#EE4352",
    fillOpacity: 0.969
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/Exclamation Mark.b4dcc3b3.svg";
export { ForwardRef as ReactComponent };